export const docCopy = {
  doc_layout_title: "Le point de départ pour apprendre TypeScript",
  doc_layout_description:
    "Trouvez des projets de démarrage TypeScript : d'Angular à React ou Node.js et CLI.",
  doc_bootstrap_title: "Outils de création pour les projets TypeScript",
  doc_bootstrap_description:
    "Toolchains pour la création de CLI, d'applications Web, d'API et d'applications.",
  doc_headline: "Ressources d'apprentissage",
  doc_headline_ts_for_js_title: "TS pour JS", // TODO: Remove, unused
  doc_headline_ts_for_js_blurb:
    "Vue d'ensemble de TypeScript pour les ingénieurs ayant des connaissances en JavaScript", // TODO: Remove, unused
  doc_headline_ts_first_title: "Débuter avec TS", // TODO: Remove, unused
  doc_headline_ts_first_blurb:
    "Une introduction pour débutants à JavaScript et TypeScript", // TODO: Remove, unused
  doc_headline_handbook_title: "Manuel", // TODO: This is not actually used on headline section, should be moved to the doc_learn section
  doc_headline_handbook_blurb: "La documentation du langage TypeScript",
  doc_headline_examples_title: "Exemples", // TODO: Remove, unused
  doc_headline_examples_blurb: "Tutoriels concrets détaillés dans le playground", // TODO: Remove, unused
  doc_start_a_project: "Commencer un nouveau projet",
  doc_start_a_project_desc:
    "Comme TypeScript est une extension de JavaScript, il n'a pas de modèle par défaut - il y en aurait trop. À la place, les projets ont leurs propres modèles de démarrage pour TypeScript avec leur propre contexte. Ces projets offrent des modèles qui prennent en charge TypeScript.",
  doc_node_npm: "Node avec npm",
  doc_node_npm_oclif_blurb: "Créez des outils en ligne de commande que vos utilisateurs adoreront",
  doc_node_npm_gluegun_blurb:
    "Une boîte à outils pratique pour créer des applications en ligne de commande utilisant TypeScript",
  doc_node_npm_tsup_blurb:
    "Empaquetez votre bibliothèque TypeScript sans aucune configuration, grâce à esbuild.",
  doc_frameworks: "Frameworks web",
  doc_frameworks_angular_blurb: "La plateforme du développeur web moderne",
  doc_frameworks_ember_blurb: "Un framework pour les développeurs web ambitieux",
  doc_frameworks_react_blurb:
    "Une librairie JavaScript pour la création d'interfaces utilisateur",
  doc_frameworks_vue_blurb: "Le framework JavaScript progressif",
  doc_frameworks_ror_blurb: "Framework web avec des conventions plutôt que de la configuration",
  doc_frameworks_asp_blurb:
    "Un framework pour la création d'applications modernes, basées sur le cloud et connectées à l'Internet",
  doc_apis: "API Node",
  doc_apis_azure_blurb: "Construisez et déployez à partir de VS Code en quelques minutes",
  doc_apis_feather_blurb:
    "Un framework pour les applications en temps réel et les API REST",
  doc_apis_graphql_blurb: "Créez votre serveur GraphQL en quelques secondes",
  doc_apis_nest_blurb:
    "Un framework Node.js progressif pour créer des applications efficaces et extensibles côté serveur",
  doc_apis_node_blurb: "Un modèle de démarrage documenté par l'équipe TS",
  doc_apis_wechat_blurb: "Utiliser le JSSDK WeChat avec TypeScript",
  doc_apis_loopback_blurb:
    "Un framework Node.js et TypeScript ultra-extensible pour la création d'API et de microservices",
  doc_apis_fastify_blurb: "Un framework web rapide et léger pour Node.js",
  doc_apis_foal_blurb:
    "Un framework Node.js élégant et complet pour construire des applications web",
  doc_react: "Projets React",
  doc_react_create_blurb: "Configurez une application web moderne en exécutant une commande",
  doc_react_gatsby_blurb:
    "Aide les développeurs à créer des sites Web et des applications ultra-rapides",
  doc_react_next_blurb: "Le framework React pour la mise en production",
  doc_react_redwood_blurb: "Le framework JS pour les applications des startups",
  doc_react_razzle_blurb:
    "Applications JavaScript universelles à rendu serveur sans configuration",
  doc_react_toolchains_title: "Toolchains recommandées",
  doc_react_toolchains_blurb: "Recommendations de l'équipe React",
  doc_apps: "Construire des applications",
  doc_apps_electron_blurb:
    "Créez des applications de bureau multiplateformes avec JavaScript, HTML et CSS",
  doc_apps_expo_blurb: "Le moyen le plus rapide de créer une application",
  doc_apps_react_native_blurb: "À apprendre une fois, pour écrire partout",
  doc_apps_native_script_blurb:
    "Framework open source pour la création d'applications mobiles véritablement natives",
  doc_apps_make_code_blurb:
    "Donne vie à l'informatique pour tous les étudiants grâce à des projets amusants",
  doc_tooling: "Outils",
  doc_tooling_babel_blurb: "Utilisez le JavaScript de nouvelle génération, dès aujourd'hui",
  doc_tooling_parcel_blurb:
    "Bundler d'applications web ultra-rapide et sans aucune configuration",
  doc_tooling_vite_blurb: "Outils pour le frontend de dernière génération",
  doc_tooling_webpack_blurb: "Regroupez vos ressources, scripts, images et styles",
  doc_learn: "Déjà familier avec TypeScript ?",
  doc_learn_3_5_release_notes_title: "Notes de mise à jour",
  doc_learn_handbook_blurb: "Documentation du langage TypeScript", // TODO: Remove, unused
  doc_learn_d_ts_title: "Guide d.ts",
  doc_learn_d_ts_blurb: "Apprenez à déclarer la structure de votre JS",
  doc_learn_playground_blurb: "Explorez et partagez du TypeScript en ligne",
  doc_cheatsheets_subnav_title: "Cheat Sheets",
  doc_learn_cheatsheets_blurb: "Syntaxe TypeScript en un clin d'œil",
}
